import { useEffect, useState } from 'react';
import ContractsPagination from './components/ListTable/ContractsPagination'

import { Box, Stack } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { ContractationButtons } from '../NavigationMenu/Header/CustomItems/ContractationButtons';
import { useSettingsContext } from '../Settings/hooks/useSettingsContext';
import { useContracts } from './hooks/useContracts';
import { ContractsElectricityListTable } from './components/ListTable/ContractsElectricityListTable';
import ContractsFilter from './components/ContractsFilter';
import { IElecContract } from './types/contracts';
import useContractation from '../Contractation/hooks/useContractation';
import { Button } from '@gisce/oficina-virtual-components';
import { useSearchParams } from 'react-router';

const ContractsListElectricity = () => {
  const { t } = useTranslation();
  const Settings = useSettingsContext();
  const [searchParams] = useSearchParams();
  const action = searchParams.get("action");
  const applyBaixaFilter = action !== null && action !== "download";

  const { 
    contracts,
    totalContractsNum,
    status, 
    fetchContracts,
    goToContract,
    goToFilteredInvoices
  } = useContracts("electricity");

  const { isContractationActive } = useContractation();

  const [filter, setFilter] = useState('');
  const [itemsPerPage, setItemsPerPage] = useState(Settings?.contracts?.itemsPerPage ?? 10);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (currentPage > 1) {
      setCurrentPage(1);
    }
  }, [filter, itemsPerPage]);

  useEffect(() => {
    if (status != "uninitialized") {
      fetchContracts(false, currentPage, itemsPerPage, filter);
    }
  }, [filter, itemsPerPage, currentPage, applyBaixaFilter]);

  return (
    <>
      <Stack spacing={3}>

        <Stack 
          direction={{md: "row"}} 
          gap={2}
          justifyContent="space-between"
          alignItems={{xs: "initial", md: "top"}}
        >
          {!Settings?.contracts?.dontShowSearchFilter &&
            <ContractsFilter 
              loading={status === "loading"}
              setFilter={setFilter}
            />
          }

          {isContractationActive && <Box>
            <ContractationButtons 
              startIcon={<Add />}
              label={t("common:text.new_customer_title")}
            />
          </Box>}
          
        </Stack>

        <ContractsElectricityListTable 
          contracts={contracts as IElecContract[]} 
          status={status} 
          goToContract={goToContract}
          goToFilteredInvoices={goToFilteredInvoices}
        />

        <ContractsPagination 
          currentPage={currentPage}
          itemsPerPage={itemsPerPage}
          itemsTotal={totalContractsNum}
          setItemsPerPage={setItemsPerPage}
          setCurrentPage={setCurrentPage}
        />

      </Stack>
    </>
  );

}

export default ContractsListElectricity;
